import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { UserService } from '../../core/services/user.service';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';

type VerificationStatus = 'loading' | 'success' | 'error';

@Component({
  selector: 'app-email-verification',
  standalone: true,
  imports: [CommonModule, ConfirmDialogComponent],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationComponent {
  status: VerificationStatus = 'loading';
  description = 'We are confirming your email address...';
  confirmText = 'OK';
  icon = 'assets/icons/checkmark-ok.svg';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
  ) {
    this.beginVerification();
  }

  get showButtons(): boolean {
    return this.status !== 'loading';
  }

  onConfirm(): void {
    if (this.status === 'success') {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/course-catalog']);
    }
  }

  private beginVerification(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const token = params['token'];
      if (!token) {
        this.setError('Verification link is missing or invalid.');
        return;
      }

      this.userService
        .confirmEmailVerification(token)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.status = 'success';
            this.description = 'Your email is verified successfully.';
            this.confirmText = 'OK';
          },
          error: (err: HttpErrorResponse) => {
            const message =
              err?.error?.message ||
              err?.error?.error ||
              'Unable to verify your email. Please request a new verification link.';
            this.setError(message);
          },
        });
    });
  }

  private setError(message: string): void {
    this.status = 'error';
    this.description = message;
    this.confirmText = 'Back to catalog';
    this.icon = 'assets/icons/exclamation-mark.svg';
  }
}
